import { Box, Grid, Skeleton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../theme/ui/Atoms/Button';
import ContainerBox from '../ContainerBox';
import { CheckIcon } from '../../../../assets';
import UserAPI from '../../../../redux/user/UserAPI';
import moment from 'moment';
import useWatchError from '../../../../shared/hooks/useWatchError';
import StoreStructureAPI from '../../../../redux/structure/store/StoreStructureAPI';
import useMyWorkspace from '../../../../redux/workspace/hooks/useMyWorkspace';

function SetupSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onClickNext = () => {
    navigate('/');
  };

  const { storeId = '', installationType = '' } = useParams<{
    storeId: string;
    installationType: string;
  }>();

  const {
    data: myUser,
    error: errorUser,
    isLoading: isLoadingUser,
  } = UserAPI.useGetMyUserQuery();
  const {
    data: workspace,
    isLoading: isLoadingWorkspace,
    error: errorWorkspace,
  } = useMyWorkspace();

  const { data: storeAudit, isLoading: isLoadingStoreAudit } =
    StoreStructureAPI.useGetStoreAuditQuery(
      { workspaceId: workspace?.id ?? '', groupId: storeId },
      {
        skip: !workspace?.id || !storeId,
        refetchOnMountOrArgChange: true,
      }
    );
  let date = moment();
  if (storeAudit?.[0]?.actionTime) {
    date = moment.unix(storeAudit?.[0]?.actionTime);
  }

  const [dateFinish] = useState(date.format('LL'));

  const name = myUser?.name || myUser?.email;

  useWatchError(errorUser);
  useWatchError(errorWorkspace);

  return (
    <ContainerBox>
      <Typography variant="h1" textAlign={'center'}>
        {t('initial_setup.finish_installation.title')}
      </Typography>
      <Box textAlign={'center'} my={4}>
        <CheckIcon height={'4rem'} />
        <Typography mt={2}>
          {isLoadingUser ? (
            <Skeleton width={200} />
          ) : (
            <Trans
              i18nKey={'initial_setup.finish_installation.description'}
              components={{ strong: <strong /> }}
              values={{ user: name }}
            />
          )}
        </Typography>

        <Typography>
          {isLoadingWorkspace || isLoadingStoreAudit ? (
            <Skeleton width={200} />
          ) : installationType === 'update' ? (
            <Trans
              i18nKey="initial_setup.finish_installation.description_update_time"
              components={{ strong: <strong /> }}
              values={{ time: dateFinish }}
            />
          ) : (
            <Trans
              i18nKey="initial_setup.finish_installation.description_install_time"
              components={{ strong: <strong /> }}
              values={{ time: dateFinish }}
            />
          )}
        </Typography>
      </Box>
      <Grid container spacing={2} mt={2} justifyContent={'center'}>
        <Grid
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            rounded
            fullWidth
            onClick={onClickNext}
          >
            {t('initial_setup.finish_installation.go_home')}
          </Button>
        </Grid>
      </Grid>
    </ContainerBox>
  );
}

export default SetupSuccess;
